<template>
  <b-form-row class="mb-2">
    <b-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      class="mb-1 mb-lg-0"
    >
      <EarningStatisticAlt
        :header="$tk('ClientPortal.Property.Earnings.Views')"
        :info="$tk('ClientPortal.Property.Earnings.Views.Info')"
        :footer-text="$tk('ClientPortal.Property.Earnings.Unique')"
        :main-value="summaryStats.firstPeriod.views"
        :main-footer="summaryStats.firstPeriod.uniqueViews"
        :compare-value="summaryStats.secondPeriod.views"
        :compare-footer="summaryStats.secondPeriod.uniqueViews"
        :compare-mode="compare"
        :loading="loadingSummaryStats"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      class="mb-1 mb-lg-0"
    >
      <EarningStatisticAlt
        :header="$tk('ClientPortal.Property.Earnings.Clicks')"
        :info="$tk('ClientPortal.Property.Earnings.Clicks.Info')"
        :footer-text="$tk('ClientPortal.Property.Earnings.Unique')"
        :main-value="summaryStats.firstPeriod.clicks"
        :main-footer="summaryStats.firstPeriod.uniqueClicks"
        :compare-value="summaryStats.secondPeriod.clicks"
        :compare-footer="summaryStats.secondPeriod.uniqueClicks"
        :compare-mode="compare"
        :loading="loadingSummaryStats"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      class="mb-1 mb-lg-0"
    >
      <EarningStatisticAlt
        :header="$tk('ClientPortal.Property.Earnings.Actions')"
        :info="$tk('ClientPortal.Property.Earnings.Actions.Info')"
        :footer-text="$tk('ClientPortal.Property.Earnings.Unique')"
        :main-value="summaryStats.firstPeriod.actions"
        :main-footer="summaryStats.firstPeriod.uniqueActions"
        :compare-value="summaryStats.secondPeriod.actions"
        :compare-footer="summaryStats.secondPeriod.uniqueActions"
        :compare-mode="compare"
        :loading="loadingSummaryStats"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      class="mb-1 mb-lg-0"
    >
      <EarningStatisticAlt
        :header="$tk('ClientPortal.Property.Earnings.CTR')"
        :info="$tk('ClientPortal.Property.Earnings.CTR.Info')"
        symbol="%"
        footer-symbol="%"
        hide-footer
        is-percentage
        :main-value="summaryStats.firstPeriod.ctr"
        :compare-value="summaryStats.secondPeriod.ctr"
        :compare-mode="compare"
        :loading="loadingSummaryStats"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      class="mb-1 mb-lg-0"
    >
      <EarningStatisticAlt
        :header="$tk('ClientPortal.Property.Earnings.FillRate')"
        :info="$tk('ClientPortal.Property.Earnings.FillRate.Info')"
        symbol="%"
        :footer-text="$tk('ClientPortal.Property.Earnings.TotalRequests')"
        is-percentage
        :main-value="summaryStats.firstPeriod.fillRate"
        :main-footer="summaryStats.firstPeriod.totalRequests"
        :compare-value="summaryStats.secondPeriod.fillRate"
        :compare-footer="summaryStats.secondPeriod.totalRequests"
        :compare-mode="compare"
        :loading="loadingSummaryStats"
      />
    </b-col>
    <b-col
      cols="12"
      sm="4"
      md="3"
      lg="2"
      class="mb-1 mb-lg-0"
    >
      <EarningStatisticAlt
        :header="$tk('ClientPortal.Property.Earnings.EarningsForTheSelectedDate')"
        :info="$tk('ClientPortal.Property.Earnings.EarningsForTheSelectedDate.Info')"
        :symbol="$currencySymbol"
        hide-footer
        :main-value="summaryStats.firstPeriod.profit"
        :compare-value="summaryStats.secondPeriod.profit"
        :compare-mode="compare"
        :loading="loadingSummaryStats"
      />
    </b-col>
  </b-form-row>
</template>

<script>
import EarningStatisticAlt from './EarningStatisticAlt.vue'

export default {
  components: {
    EarningStatisticAlt,
  },
  props: {
    summaryStats: {
      type: Object,
      default: () => {},
    },
    compare: {
      type: Boolean,
      default: false,
    },
    loadingSummaryStats: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
